import { Tag } from 'antd';
import moment from 'moment';
import { connect } from 'react-redux';
import React, { Fragment, useState, useEffect, useRef } from 'react';
import cloneDeep from 'lodash.clonedeep';
import ReactEcharts from '../../Echarts/Echarts';
import { windBarbMock } from '../../../Mock/MockJson';
import { config } from '../../constant';
import { ErrorComponent, NoRecordComponent } from '../../Utils';
import { getChartDataWithoutSelection, getChartDataWithSelection } from '../../ChartCalls';

const WindBarb = (props) => {
  const [option, setOption] = useState({});
  const [refreshDateTime, setRefreshDateTime] = useState(moment());
  const [errorInAPI, setErrorInAPI] = useState(false);
  const [noDataInDB, setNoDataInDB] = useState(false);
  let timeTicket = useRef(null);
  let requestCheck = useRef(true);
  const abortController = useRef(new window.AbortController());

  const {
    graphprops,
    selectionDate,
    selectionMonth,
    DeviceCode,
    selectionDateRange,
    dayMonthYear,
    currentTimeZone,
  } = props;

  useEffect(() => {
    if (timeTicket.current) {
      clearInterval(timeTicket.current);
    }
    let refreshTime = graphprops?.refreshTime ? graphprops.refreshTime * 60000 : config.defaultRefreshTime;
    timeTicket.current = setInterval(() => {
      if (requestCheck.current) {
        getData();
      }
    }, refreshTime);
    return () => {
      abortController.current.abort();
      clearInterval(timeTicket.current);
    };
  }, []);

  useEffect(() => {
    getData(props);
  }, [
    selectionDate,
    selectionMonth,
    selectionDateRange,
    DeviceCode,
    dayMonthYear,
    props.translationCache
  ]);

  const getData = async () => {
    let { graphprops } = props;
    requestCheck.current = false;
    setErrorInAPI(false);
    setNoDataInDB(false);
    let json = [];
    if (graphprops && graphprops.enableMock && graphprops.enableMock === true) {
      json = windBarbMock;
      requestCheck.current = true;
    } else {
      if (graphprops?.graph === 'rangeBar' && graphprops?.currentDateData !== undefined) {
        json = graphprops.currentDateData;
      } else {
        if (
          graphprops &&
          ((graphprops.DashboardLevelSelection === 'datePicker' ||
            graphprops.GraphLevelSelection === 'datePicker') &&
            selectionDate) ||
          (
            (graphprops.DashboardLevelSelection === 'monthPicker' ||
              graphprops.GraphLevelSelection === 'monthPicker') &&
            selectionMonth) ||
          (
            (graphprops.DashboardLevelSelection === 'dateRangePicker' ||
              graphprops.GraphLevelSelection === 'dateRangePicker') &&
            selectionDateRange) ||
          (
            (graphprops.DashboardLevelSelection === 'dateMonthYearPicker' ||
              graphprops.GraphLevelSelection === 'dateMonthYearPicker') &&
            dayMonthYear) ||
          (
            (graphprops.DashboardLevelSelection === 'deviceSelection' ||
              graphprops.GraphLevelSelection === 'deviceSelection') &&
            DeviceCode)
        ) {
          json = await getChartDataWithSelection({
            graphprops,
            selectionDate,
            selectionMonth,
            selectionDateRange,
            DeviceCode,
            dayMonthYear,
            abortController: abortController.current,
            currentTimeZone,
          });
          requestCheck.current = true;
        } else if (
          graphprops.GraphLevelSelection === 'none' ||
          graphprops.DashboardLevelSelection === 'none'
        ) {
          json = await getChartDataWithoutSelection({
            graphprops,
            abortController: abortController.current,
            DeviceCode,
            TimeZone: currentTimeZone,
          });
          requestCheck.current = true;
        }
      }
    }

    if ((json && json.message) || (Array.isArray(json) && json.length === 0 && !graphprops.enableMock)) {
      if (json.message) {
        setErrorInAPI(true);
      } else if (json.length === 0) {
        setNoDataInDB(true);
      }
    } else {
      if (Array.isArray(json)) {
        let graphObject = graphprops[graphprops.graph] || '';
        let { YAxis } = graphObject;
        let YAxisList = YAxis ? JSON.parse(YAxis) : [];
        // let values = [];
        let name = '';
        let tagnames = [];
        let directionMap = {};
        let legendsdata = [];
        let arrowSize = 18;
        let dims = {
          time: 0,
          windSpeed: 1,
          R: 2,
          waveHeight: 3
        };
        var fn = function renderArrow(params, api) {
          // var value = params.value;
          var point = api.coord([api.value[dims.time], api.value[dims.windSpeed]]);
          return {
            type: 'path',
            shape: {
              pathData: 'M31 16l-15-15v9h-26v12h26v9z',
              x: -arrowSize / 2,
              y: -arrowSize / 2,
              width: arrowSize,
              height: arrowSize
            },
            rotation: directionMap[api.value[dims.R]],
            position: point,
            style: api.style({
              stroke: '#555',
              lineWidth: 1
            })
          };
        };


        let data = json && Array.isArray(json) && json.map((entry) => {
          return [entry.time, entry.windSpeed, entry.R, entry.waveHeight];
        });

        let wind = [
          'W', 'WSW', 'SW', 'SSW', 'S', 'SSE', 'SE', 'ESE', 'E', 'ENE', 'NE', 'NNE', 'N', 'NNW', 'NW', 'WNW'
        ];
        wind.forEach((name, index) => {
          directionMap[name] = (Math.PI / 8) * index;
        });

        json.forEach((val) => {
          if (val.tagname !== name) {
            if (!tagnames.includes(val.tagname)) {
              tagnames.push(val.tagname);
              name = val.tagname;
              legendsdata.push({
                name: val.tag_description,
                icon: 'roundRect',
                textStyle: {
                  color: props.theme.algorithm === "dark" ? 'white' : 'black',
                  fontSize: 16,
                  fontWeight: 'bold'
                }
              });
            }
          }
        });

        let yAxisData = Array.isArray(YAxisList) && YAxisList.length > 0 ? [...YAxisList] : null;
        let yaxis = yAxisData && yAxisData.length > 0
          ? yAxisData
          : [{ type: 'value' }, { type: 'value' }]; 

        let xAxis = {
          type: 'time',
          maxInterval: 3600 * 1000 * 24,
          splitLine: {
            lineStyle: {
              color: '#ddd'
            }
          },
          axisLine: {
            lineStyle: {
              color: props.theme.algorithm === "dark" ? 'white' : 'black'
            }
          },
          axisTick: {
            lineStyle: {
              color: props.theme.algorithm === "dark" ? 'white' : 'black'
            }
          },
          axisLabel: {
            color: props.theme.algorithm === "dark" ? 'white' : 'black'
          }
        };

        let series = [
          {
            type: 'line',
            yAxisIndex: 1,
            showSymbol: false,
            hoverAnimation: false,
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  { offset: 0, color: 'rgba(88,160,253,1)' },
                  { offset: 0.5, color: 'rgba(88,160,253,0.7)' },
                  { offset: 1, color: 'rgba(88,160,253,0)' }
                ]
              }
            },
            lineStyle: {
              normal: {
                color: 'rgba(88,160,253,1)'
              }
            },
            itemStyle: {
              normal: {
                color: 'rgba(88,160,253,1)'
              }
            },
            encode: {
              x: dims.time,
              y: dims.waveHeight
            },
            data: data,
            z: 2
          },
          {
            type: 'custom',
            renderItem: fn,
            encode: {
              x: dims.time,
              y: dims.windSpeed
            },
            data: data,
            z: 10
          },
          {
            type: 'line',
            symbol: 'none',
            encode: {
              x: dims.time,
              y: dims.windSpeed
            },
            lineStyle: {
              normal: {
                color: '#aaa',
                type: 'dotted'
              }
            },
            data: data,
            z: 1
          }
        ];

        const option = cloneDeep(getOption());
        option.xAxis = xAxis;
        option.yAxis = yaxis;
        option.series = series;
        setOption(option);
        setRefreshDateTime(moment());
      }
    }
    setErrorInAPI(errorInAPI);
    setNoDataInDB(noDataInDB);
  };

  const getOption = () => {
    let graphObject = props.graphprops[props.graphprops.graph]
      ? props.graphprops[props.graphprops.graph]
      : '';
    let { colors, VisualMap } = graphObject;
    let visualMapList = VisualMap ? JSON.parse(VisualMap) : [];
    let option = {
      title: {},
      color: colors,
      tooltip: {
        trigger: 'axis',
        formatter: function (params) {
          return ['Wind Speed,Wind Direction,Tide Level' + params[0].value.join('</br>')];
        }
      },
      visualMap: {
        type: 'piecewise',
        orient: 'horizontal',
        left: 'center',
        top: 10,
        pieces: visualMapList,
        seriesIndex: 1,
        dimension: 1,
        textStyle: {
          fontWeight: 'bold',
          fontSize: 15,
          color: props.theme.algorithm === "dark" ? 'white' : 'black'
        }
      },
      dataZoom: [
        {
          type: 'inside',
          xAxisIndex: 0,
          minSpan: 5
        },
        {
          type: 'slider',
          xAxisIndex: 0,
          minSpan: 5,
          height: 20,
          bottom: 50,
          handleIcon:
            'M10.7,11.9H9.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4h1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
          handleSize: '120%'
        }
      ],
      xAxis: {
        axisLine: {
          lineStyle: {
            color: props.theme.algorithm === "dark" ? 'white' : 'black'
          }
        },
        splitLine: {
          lineStyle: {
            color: '#ddd'
          }
        }
      },
      yAxis: [],
      toolbox: {
        showTitle: false,
        itemSize: 25,
        feature: {
          saveAsImage: {
            backgroundColor: 'black',
            title: 'download',
            name: props.graphprops.title,
            iconStyle: {
              borderColor: '#8c8c8c',
              borderWidth: 2
            }
          }
        }
      },
      series: [
        {
          name: 'value',
          type: 'line',
          data: []
        }
      ]
    };
    return option;
  };

  return (
    <Fragment>
      {props.graphprops && props.graphprops.checked === true ? (
        <Tag className="graphTag" color="blue">
          {refreshDateTime ? moment(refreshDateTime).format('YYYY-MM-DD HH:mm:ss') : ''}
        </Tag>
      ) : null}
      {noDataInDB || errorInAPI ? (
        noDataInDB ? (
          <NoRecordComponent />
        ) : (
          <ErrorComponent />
        )
      ) : (
        <ReactEcharts
          option={option}
          notMerge={true}
          lazyUpdate={true}
          style={{ height: '90%', width: '100%' }}
          className="react_for_echarts"
        />
      )}
    </Fragment>
  );
};


const mapStateToProps = (state) => {
  return {
    theme: state.ThemeReducer,
    translationCache: state.TranslationReducer.translationCache,
    currentTimeZone: state.LayoutReducer.currentTimeZone
  };
};


export default connect(mapStateToProps)(WindBarb);